import type React from 'react'
import type { JSX } from 'react'

import { TextBox, TextBoxColors, TextBoxTypes } from 'atoms/TextBox'
import { COLOR } from 'vars/index'
import { Card } from '../Card'
import { CARDS_ASPECT_RATIO, CardCorners } from '../Card.h'
import { CatchupProgramCardSC } from './CatchupProgramCard.styled'

export interface ICatchupProgramCardProps {
  // logic
  children?: React.ReactNode

  title?: string
  text: string
  onClick?: () => void

  // styles
  cardAspectRatio?: (typeof CARDS_ASPECT_RATIO)[keyof typeof CARDS_ASPECT_RATIO]
  gridCard?: boolean
  backgroundColorDefault?: COLOR
  backgroundPoster?: COLOR
  backgroundColorHovered?: COLOR
  backgroundColorPressed?: COLOR
  titleColorDefault?: TextBoxColors
  titleFont?: TextBoxTypes
  textColorDefault?: TextBoxColors
  textFont?: TextBoxTypes
  //storybook
  width?: string
  corners?: CardCorners
}

export const CatchupProgramCard = ({
  children,
  onClick,
  title,
  text,
  cardAspectRatio = CARDS_ASPECT_RATIO.HORIZONTAL_DEFAULT,
  backgroundColorDefault = COLOR.SURFACE_OPACITY_LIGHT_10,
  titleColorDefault = TextBoxColors.BASE_MAIN_DEFAULT,

  titleFont = TextBoxTypes.Footnote5,
  textColorDefault = TextBoxColors.SURFACE_DARK_7,

  textFont = TextBoxTypes.Caption4,

  gridCard = true,
  corners = CardCorners.CORNERS_0,
}: ICatchupProgramCardProps): JSX.Element => {
  return (
    <Card
      backgroundColor={backgroundColorDefault}
      aspectRatio={cardAspectRatio}
      gridCard={gridCard}
      posterEnabled={false}
      onClick={onClick}
      corners={corners}
    >
      <CatchupProgramCardSC>
        {children || (
          <>
            <TextBox
              title={title}
              font={titleFont}
              color={titleColorDefault}
              maxLines={2}
            />
            <TextBox
              title={text}
              font={textFont}
              color={textColorDefault}
              maxLines={1}
            />
          </>
        )}
      </CatchupProgramCardSC>
    </Card>
  )
}
